import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../components/Navbar";

const DeleteAccount = () => {
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDevModal, setShowDevModal] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [reasons, setReasons] = useState([]);

  const deleteReasons = [
    "I'm not getting enough campaigns",
    "The platform is too complicated",
    "I found a better alternative",
    "I'm taking a break from influencer marketing",
    "I have privacy concerns",
    "I'm not satisfied with the payment process",
    "Other"
  ];

  const handleReasonChange = (reason) => {
    if (reasons.includes(reason)) {
      setReasons(reasons.filter(r => r !== reason));
    } else {
      setReasons([...reasons, reason]);
    }
  };

  const handleDeleteAccount = async () => {
    if (confirmationText !== "DELETE") {
      toast.error("Please type 'DELETE' to confirm account deletion");
      return;
    }

    if (reasons.length === 0) {
      toast.error("Please select at least one reason for deleting your account");
      return;
    }

    // setIsDeleting(true);
    
    // try {
    //   // Simulate API call - replace with actual delete account API
    //   await new Promise(resolve => setTimeout(resolve, 2000));
      
    //   toast.success("Account deletion request submitted successfully");
      
    //   // Clear local storage and redirect to login
    //   setTimeout(() => {
    //     localStorage.clear();
    //     navigate("/login");
    //   }, 2000);
      
    // } catch (error) {
    //   toast.error("Failed to delete account. Please try again.");
    //   setIsDeleting(false);
    // }

    // Show development modal instead of actual deletion
    setShowConfirmModal(false);
    setShowDevModal(true);
  };

  const handleGoToDashboard = () => {
    setShowDevModal(false);
    navigate("/influencer/dashboard");
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
              <i className="fas fa-exclamation-triangle text-2xl text-red-600"></i>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Delete Account</h1>
            <p className="text-gray-600">
              We're sorry to see you go. Please let us know why you're leaving.
            </p>
          </div>

          {/* Warning Card */}
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 mb-8">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <i className="fas fa-info-circle text-red-600 text-lg"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-red-800 mb-2">Important Information</h3>
                <ul className="text-sm text-red-700 space-y-1">
                  <li>• This action cannot be undone</li>
                  <li>• All your data, campaigns, and earnings will be permanently deleted</li>
                  <li>• You will lose access to all affiliate links and tracking</li>
                  <li>• Any pending payments will be forfeited</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Reasons Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Why are you deleting your account? (Select all that apply)
            </h3>
            <div className="space-y-3">
              {deleteReasons.map((reason, index) => (
                <label key={index} className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={reasons.includes(reason)}
                    onChange={() => handleReasonChange(reason)}
                    className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                  />
                  <span className="text-gray-700">{reason}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Feedback Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Additional Feedback (Optional)
            </h3>
            <textarea
              placeholder="Help us improve by sharing your thoughts..."
              className="w-full h-24 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 resize-none"
            />
          </div>

          {/* Confirmation Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Confirm Account Deletion
            </h3>
            <p className="text-gray-600 mb-4">
              To confirm that you want to delete your account, please type <strong>DELETE</strong> in the box below:
            </p>
            <input
              type="text"
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
              placeholder="Type DELETE to confirm"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => navigate("/influencer/dashboard/settings")}
              className="flex-1 bg-gray-100 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              onClick={() => setShowConfirmModal(true)}
              disabled={confirmationText !== "DELETE" || reasons.length === 0}
              className="flex-1 bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
            >
              Delete Account
            </button>
          </div>
        </div>

        {/* Confirmation Modal */}
        {showConfirmModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
                  <i className="fas fa-exclamation-triangle text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Final Confirmation
                </h3>
                <p className="text-gray-600 mb-6">
                  Are you absolutely sure you want to delete your account? This action cannot be undone.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={() => setShowConfirmModal(false)}
                    className="flex-1 bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDeleteAccount}
                    disabled={isDeleting}
                    className="flex-1 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 disabled:bg-red-400 transition-colors font-medium"
                  >
                    {isDeleting ? (
                      <span className="flex items-center justify-center">
                        <i className="fas fa-spinner fa-spin mr-2"></i>
                        Deleting...
                      </span>
                    ) : (
                      "Yes, Delete Account"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Development Modal */}
        {showDevModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-orange-100 mb-4">
                  <i className="fas fa-tools text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Feature Under Development
                </h3>
                <p className="text-gray-600 mb-6">
                  The account deletion feature is currently under development and will be available soon. 
                  We're working hard to make this process smooth and secure for you.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={handleGoToDashboard}
                    className="flex-1 bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition-colors font-medium"
                  >
                    Go to Dashboard
                  </button>
                  <button
                    onClick={() => setShowDevModal(false)}
                    className="flex-1 bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                  >
                    Stay Here
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Toast notifications */}
        <ToastContainer />
      </div>
    </>
  );
};

export default DeleteAccount;
